angular
  .module('vcio-toolkit')

  .constant('EMAIL_REGEX', /^[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9-]+(\.[a-z0-9-]{2,4})+$/i)
  // .constant('EMAIL_REGEX', /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/i)

  .constant('FILENAME_REGEX', /^[0-9a-zA-Z\^\&\'\@\{\}\[\]\$\=\!\-\#\(\)\.\,\%\+\~\_ ]+$/);
